export const MODAL_TYPES = {
  CANCEL: 'CANCEL',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  FAILED_WITH_VALID: 'FAILED_WITH_VALID',
  FAILED_WITH_NO_VALID: 'FAILED_WITH_NO_VALID',
  SEND_JOURNEY: 'SEND_JOURNEY',
  CREATE_JOURNEY: 'CREATE_JOURNEY',
  DELETE: 'DELETE',
};
